export default {"src":"/_next/static/media/carrer-file.44811ea4.svg","height":18,"width":14,"blurWidth":0,"blurHeight":0};